import { ANTD_TABLE_TABLE_ACTIONS } from "../thunks/antdTable.thunk";

interface TableSliceProps {
  tableData: {
    [string: string]: {
      loading: false;
      error: {};
      requestId?: string;
      data: {
        total_contracts_synced?: any;
        contracts_moved?: any;
        contracts_failed?: any;
        contracts_not_moved?: any;
        destination_drive_link?: string | undefined;
        synced_by?: any;
        synced_on?: any;
        year?: any;
        vertical?: string;
        count: number;
        total_count?: number;
        next: string | null;
        previous: string | null;
        results: [];
        page: number;
        pageSize: number;
        clausesForVertical: [];
        newlyAddedClausesByVertical: { [verticalId: string]: string[] };
        selectedColumns: [];
        allClauseColumns: [];
        supplierFilterOptions?: string[][];
        filters: {
          [key: string]: {};
        };
        filtersForRequestBody: {
          filter: [];
        };
      };
      showRecent?: boolean;
    };
  };
}

const defaultState = {
  tableData: {},
};

const initialState: TableSliceProps = defaultState;

export default function antdTableReducer(state = initialState, action: any) {
  switch (action.type) {
    case ANTD_TABLE_TABLE_ACTIONS.UPDATE_LOAD_OR_ERROR_STATE_OF_TABLE:
      var { entity, data } = action?.payload;
      state = {
        tableData: {
          ...state.tableData,
          [entity]: {
            ...state?.tableData?.[entity],
            ...data,
          },
        },
      };
      return state;

    case ANTD_TABLE_TABLE_ACTIONS.SETTING_TABLE_DATA:
      entity = action?.payload?.entity;
      data = action?.payload?.data;

      state = {
        tableData: {
          ...state.tableData,
          [entity]: {
            ...state?.tableData?.[entity],
            data: {
              ...state.tableData?.[entity]?.data,
              ...data,
            },
            error: {},
          },
        },
      };

      return state;

    case ANTD_TABLE_TABLE_ACTIONS.ANT_TABLE_UPDATE_SHOW_RECENT:
      entity = action.payload.entity;
      const showRecent = action.payload.showRecent;
      state = {
        ...state,
        tableData: {
          ...state.tableData,
          [entity]: {
            ...state.tableData?.[entity],
            showRecent: showRecent,
          },
        },
      };
      return state;

    case ANTD_TABLE_TABLE_ACTIONS.RESET_ANTD_TABLE_STATE:
      entity = action.payload.entity;
      state = {
        ...state,
        tableData: {
          ...state.tableData,
          [entity]: {
            showRecent: state.tableData?.[entity]?.showRecent,
          },
        },
      };
      return state;

    case ANTD_TABLE_TABLE_ACTIONS.UPDATE_TABLE_ENTITY_DATA:
      entity = action.payload.entity;
      data = action.payload.data;
      const rowId = action.payload.rowId;

      state = {
        ...state,
        tableData: {
          ...state.tableData,
          [entity]: {
            ...state.tableData?.[entity],
            data: {
              ...state.tableData?.[entity]?.data,
              results: state.tableData?.[entity]?.data?.results?.map(
                (row: any) => {
                  if (row?.id === rowId) {
                    return {
                      ...row,
                      ...data,
                    };
                  }
                  return row;
                }
              ),
            },
          },
        },
      };

      return state;

    case ANTD_TABLE_TABLE_ACTIONS.REMOVE_TABLE_ENTITY_ROW:
      entity = action.payload.entity;
      const rowIdToRemove = action.payload.rowId;
      state = {
        ...state,
        tableData: {
          ...state.tableData,
          [entity]: {
            ...state.tableData?.[entity],
            data: {
              ...state.tableData?.[entity]?.data,
              results: state.tableData?.[entity]?.data?.results?.filter(
                (row: any) => row?.id !== rowIdToRemove
              ),
              count: state.tableData?.[entity]?.data?.count - 1,
            },
          },
        },
      };
      return state;

    default:
      return state;
  }
}
